
import { Component, Mixins } from "vue-property-decorator";
import { IBarcodeItemsPropertyEditable, instanceOfIBarcodeItemsPropertyEditable } from "../../../../../domain/editableFormat/properties";
import { IBarcodeItem } from "../../../../../domain/editableFormat/objects/IBarcodeObject";
import { IBarcodeInformationSpecification } from "../../../../../domain/editableFormat/IFormatSpecification";

@Component
export default class BarcodeItemPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IBarcodeItemsPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IBarcodeItemsPropertyEditable) => T, defaultValue: T) => T;

  get isBarcodeItemsPropertyEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIBarcodeItemsPropertyEditable(s) && s.barcodeItems().isEditable() && s.name().isEditable(), false);
  }

  get barcodeItems(): IBarcodeItem[] {
    return this.readPropertyOrDefault(s => s.barcodeItems().getValue(), []);
  }

  set barcodeItems(value: IBarcodeItem[]) {
    this.writePropertyWhenValid(s => s.barcodeItems().setValue(value));
  }

  get selectableBarcodeInformations(): IBarcodeInformationSpecification[] {
    return this.readPropertyOrDefault(s => s.getSelectableBarcodeInformations(), []);
  }
}
